import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './Invoices.frontend.types'

@Injectable({ providedIn: 'root' })
export class Invoices_create_invoice_line_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { invoiceId: number, billingCodeId: number, quantity: number, unitPrice: number, minimumCharge: number, notes?: string, description?: string }): Promise<{ reason?: string, invoiceLineId?: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.invoiceId)) {
      missingRequiredInParams.push('\'invoiceId\'');
    }
    if (isNil(inParams.billingCodeId)) {
      missingRequiredInParams.push('\'billingCodeId\'');
    }
    if (isNil(inParams.quantity)) {
      missingRequiredInParams.push('\'quantity\'');
    }
    if (isNil(inParams.unitPrice)) {
      missingRequiredInParams.push('\'unitPrice\'');
    }
    if (isNil(inParams.minimumCharge)) {
      missingRequiredInParams.push('\'minimumCharge\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Invoices/functions/create_invoice_line_flow`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

}

